import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EndGameComponent } from './endGame.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [EndGameComponent],
  exports: [EndGameComponent]
})
export class EndGameModule { }
